export class MenuItem {
    public title: string;
    public routerLink: string;
    public menuIcon: string;
    public enabled: boolean;
}
